module.exports = __webpack_public_path__ + "static/media/start_1279169.73c59965.svg";